import { reportSentryError } from '../sentry';
import { STORAGE_PREFIX } from './constants';
import { klarnaIframeStorage } from './klarnaIframeStorage';
import { localStorage } from './localStorage';
import { sessionStorage } from './sessionStorage';
export const localStorageHelper = (storageKey) => {
    const storageKeyWithPrefix = `${STORAGE_PREFIX}${storageKey}`;
    try {
        return localStorage(storageKeyWithPrefix);
    }
    catch {
        reportSentryError(`Storage type: localStorage not supported`);
    }
};
export const sessionStorageHelper = (storageKey) => {
    const storageKeyWithPrefix = `${STORAGE_PREFIX}${storageKey}`;
    try {
        return sessionStorage(storageKeyWithPrefix);
    }
    catch {
        reportSentryError(`Storage type: sessionStorage not supported`);
    }
};
export const klarnaIframeStorageHelper = (storageKey) => {
    const storageKeyWithPrefix = `${STORAGE_PREFIX}${storageKey}`;
    try {
        return klarnaIframeStorage(storageKeyWithPrefix);
    }
    catch {
        reportSentryError(`Storage type: klarnaIframeStorage not supported`);
    }
};
